// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_split-panel-side_j4v3w_1dcwh_145:not(#\\9 ){position:sticky;z-index:830;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
